import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import lineBreaker from 'helpers/LineBreaker';
import { formatarMoeda } from 'util/numberUtil';
import SemDados from '../SemDados';

const RegionalCustoMedio = (props) => {
  const { data } = props;
  const titulo = 'CUSTO MÉDIO POR SOLICITAÇÃO MÊS REGIONAL X BRASIL';

  if (!data || data.length < 1) {
    return <SemDados titulo={titulo} />;
  }

  const itensAnos = [];
  const itensMeses = [];
  const itensRegionais = [];
  // popula os arrays de anos e meses
  data.forEach((ano) => {
    itensAnos.push(ano.ano);

    ano.data.forEach((mes) => {
      itensMeses.push(mes);

      mes.regional.forEach((regional) => {
        itensRegionais.push(regional);
      });
    });
  });

  const itensCusto = itensRegionais.map((regional) => {
    return regional.custoMedio;
  });

  const maxValue = Math.max(...itensCusto);

  const larguraGrafico = itensRegionais.length * 100;
  // considerando que o grafico tem 20px de padding, permitindo um melhor ajuste das annotations
  const larguraColuna = (larguraGrafico - 20) / itensRegionais.length;

  const calculateAnnotationPoint = () => {
    const tmpAnnotation = [];
    let index = 0;
    itensMeses.forEach((mes) => {
      const media =
        mes.regional.reduce((a, b) => {
          return a + b.custoMedio;
        }, 0) / mes.regional.length;
      tmpAnnotation.push({
        x: index * larguraColuna,
        y: 10,
        marker: {
          size: 0,
        },
        label: {
          borderColor: undefined,
          text: `Média: R$${parseInt(media, 10).toLocaleString('pt-BR')}`,
          textAnchor: 'start',
          style: {
            background: '#b4282f99',
            color: '#fff',
            fontSize: '12px',
            fontWeight: 700,
          },
        },
      });

      index += mes.regional.length;
    });
    return tmpAnnotation;
  };

  const calculateAnnotationY = () => {
    const tmpAnnotation = [];
    let index = 0;
    itensMeses.forEach((mes) => {
      const media =
        mes.regional.reduce((a, b) => {
          return a + b.custoMedio;
        }, 0) / mes.regional.length;
      tmpAnnotation.push({
        y: media,
        borderColor: '#fe9b99',
        strokeDashArray: 7,
        width: `${mes.regional.length * larguraColuna}`,
        offsetX: index * larguraColuna,
      });

      index += mes.regional.length;
    });
    return tmpAnnotation;
  };

  const series = [
    {
      name: 'Custo Médio',
      data: itensCusto,
    },
  ];

  const options = {
    annotations: {
      yaxis: calculateAnnotationY(),
      points: calculateAnnotationPoint(series),
    },
    colors: ['#e36823', '#b4282f'],
    legend: {
      showForSingleSeries: true,
      // formatter: (seriesName) => {
      //   return [seriesName.toUpperCase()];
      // },
      show: true,
      position: 'top',
      horizontalAlign: 'left',
      floating: true,
      offsetX: 0,
      offsetY: 6,
    },
    plotOptions: {
      bar: {
        hideZeroBarsWhenGrouped: false,
        horizontal: false,
        columnWidth: '70%',
        dataLabels: {
          position: 'top',
        },
        colors: {},
      },
    },
    stroke: {
      colors: ['transparent'],
      width: 4,
    },
    xaxis: {
      position: 'bottom',
      show: true,
      categories: itensRegionais.map((regional) => {
        return regional.nome;
      }),
      group: {
        style: {
          fontSize: '12px',
          fontWeight: 700,
        },
        groups: itensMeses.map((mes) => {
          return {
            title: mes.nome,
            cols: mes.regional.length,
          };
        }),
      },
      labels: {
        show: true,
        style: {
          fontWeight: 600,
        },
        formatter: (value) => {
          const lines = lineBreaker(value.toUpperCase(), 7);
          return lines;
        },
      },
      axisBorder: {
        show: true,
        color: '#a3a3a3',
      },
      axisTicks: {
        show: true,
        color: '#a3a3a3',
      },
    },
    yaxis: {
      max: maxValue * 1.2,
      show: false,
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        // top: 0,
        right: 10,
        // bottom: 0,
        left: 10,
      },
    },
    chart: {
      parentHeightOffset: 5,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      hideOverflowingLabels: false,
      textAnchor: 'middle',
      offsetX: 0,
      offsetY: -19,
      formatter: (value) => {
        return value === null ? formatarMoeda(0) : formatarMoeda(value);
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      shared: false,
      followCursor: true,
      intersect: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              Mes: <span id="data">${itensRegionais[dataPointIndex].mes}</span>
            </span>
            <span>
              Custo Médio: <span id="data">R$${formatarMoeda(
                itensCusto[dataPointIndex]
              )}</span>
            </span>
          </div>
          `;
      },
    },
  };
  console.log(options.xaxis.categories.length);
  return (
    <div className="grafico" style={{ overflow: 'hidden' }}>
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <div className="scrollable-horizontal">
        <Chart
          options={options}
          series={series}
          type="bar"
          height="250"
          style={{
            width: larguraGrafico,
            // minWidth: '100%',
          }}
        />
      </div>
    </div>
  );
};

export default RegionalCustoMedio;
